/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {notificationService} from "../views/service/notification.service";

const state = {
  modalData: {},
  dashboardNotifications:[],
  dashboardImportantNotifications:[],
  operationsNotifications:[],
  WorkNotifications:[],
  notifications:[],
  notificationCounters: {
    numberOfSimulationsNotifications: 0,
    numberOfWorksNotifications: 0
  }
};

const getters = {
  getModalData: (state) => state.modalData,
  getDashboardNotifications: (state) => state.dashboardNotifications,
  getDashboardImportantNotifications: (state) => state.dashboardImportantNotifications,
  getOperationsNotifications: (state) => state.operationsNotifications,
  getWorkNotifications: (state) => state.WorkNotifications,
  getNotifications: (state) => state.notifications,
  getNotificationCounters: (state) => state.notificationCounters
};

const actions = {
  openModal({ commit }, data) {
    commit("setModalData", data);
    notificationService.showNotificationModal(data);
  },
  closeModal({ commit }, data) {
    commit("clear");
    notificationService.closeNotificationModal(data);
  },
  getDashboardNotificationsAction({ dispatch, commit }) {
    dispatch('loader/showDashboardNotificationLoader', true, { root: true });
    notificationService.fetchDashboardNotifications().then(
      (result) => {
        commit("setDashboardNotifications", result);
      },
      (error) => {
        console.log(error);
      }
    ).finally(() => dispatch('loader/hideDashboardNotificationLoader', false, { root: true })
  );
  },
  getDashboardImportantNotificationsAction({ dispatch, commit }) {
    dispatch('loader/showDashboardNotificationLoader', true, {root: true});
    notificationService.fetchDashboardImportantNotifications(true).then(
        (result) => {
          commit("setDashboardImportantNotifications", result);
        },
        (error) => {
          console.log(error);
        }
    ).finally(() => dispatch('loader/hideDashboardNotificationLoader', false, {root: true})
    );
  },
  getOperationNotificationsAction({ dispatch, commit }, { operationId }) {
    dispatch('loader/showOperationNotificationLoader', true, { root: true });
    notificationService.fetchOperationNotifications(operationId).then(
      (result) => {
        commit("setOperationsNotifications", result);
      },
      (error) => {
        console.log(error);
      }
    ).finally(() => dispatch('loader/hideOperationNotificationLoader', false, { root: true })
  );
  },
  getWorkNotificationsAction({ dispatch, commit }, { workId }) {
    dispatch('loader/showWorkNotificationLoader', true, { root: true });
    notificationService.fetchWorkNotifications(workId).then(
        (result) => {
          commit("setWorkNotifications", result);
        },
        (error) => {
          console.log(error);
        }
    ).finally(() => dispatch('loader/hideWorkNotificationLoader', false, { root: true })
    );
  },
  getNotificationCountersAction({ commit }) {
    notificationService.fetchNotificationCounters().then(
        (result) => {
          commit("setNotificationCounters", result);
        },
        (error) => {
          console.log(error);
        }
    );
  },
};

const mutations = {
  setModalData(state, data) {
    state.modalData = data;
  },
  clear(state) {
    state.modalData = {};
  },
  setDashboardNotifications(state, val) {
    state.dashboardNotifications = val;
  },
  setDashboardImportantNotifications(state, val) {
    state.dashboardImportantNotifications = val;
  },
  setOperationsNotifications(state, val) {
    state.operationsNotifications = val;
  },
  setWorkNotifications(state, val) {
    state.WorkNotifications = val;
  },
  setNotifications(state, val) {
    state.notifications = val;
  },
  setNotificationCounters(state, val) {
    state.notificationCounters = val;
  },
};

export const notification = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
